import { createFileRoute } from "@tanstack/react-router"
import { PersonsTab } from "./_persons-tab"

export const Route = createFileRoute("/settings/persons")({
  component: PersonsTab,
})
